// removed by extract-text-webpack-plugin
module.exports = {"yAxisTickContainer":"_3pvC","yAxisTick":"_21FC"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/LandingPage/Chart/YAxis/YAxisTick/styles.scss
// module id = 440
// module chunks = 0